import { FC } from 'react'

//import notFoundImage from 'shared/assets/img/not_found.png'
import styles from './NotFound.module.scss'

const NotFound: FC = () => {
  //return <img src={notFoundImage} className={styles.img} />
  return <div className={styles.notFoundImg}></div>
}

export default NotFound
